import { Truck, ShieldCheck, RefreshCcw, Award } from "lucide-react";

const ITEMS = [
  { Icon: Truck, title: "Nationwide Delivery", body: "1–4 business days across South Africa." },
  { Icon: ShieldCheck, title: "Secure SA Payments", body: "Yoco · PayFast · Ozow · Payflex · Card · Apple Pay." },
  { Icon: RefreshCcw, title: "30-Day Returns", body: "Easy exchanges on uncut, unworn lace wigs." },
  { Icon: Award, title: "Premium Hair Guarantee", body: "Soft, durable, tangle-resistant human hair." },
];

export default function TrustBar() {
  return (
    <section data-testid="trust-bar" className="bg-nude border-y border-stone-line">
      <div className="max-w-7xl mx-auto grid grid-cols-2 lg:grid-cols-4 px-6">
        {ITEMS.map(({ Icon, title, body }) => (
          <div key={title} className="py-8 lg:py-12 px-3 text-center border-r last:border-r-0 border-stone-line">
            <Icon strokeWidth={1.25} className="w-6 h-6 mx-auto text-charcoal" />
            <p className="font-serif text-base lg:text-lg mt-3">{title}</p>
            <p className="text-xs text-stone mt-1">{body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
